"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combinationsWithReplacement = combinationsWithReplacement;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

var _factorial = _interopRequireDefault(require("../../internal/factorial"));

var _map = require("../$map/map");

var _range = require("../range/range");

var _product = require("../product/product");

var _isSorted = require("../$is-sorted/is-sorted");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function combinationsWithReplacementSize(len, n) {
  if (len === 0 || n === 0 || n > len) return 0;
  return Number((0, _factorial.default)(len + n - 1) / ((0, _factorial.default)(n) * (0, _factorial.default)(len - 1)));
}

function combinationsWithReplacement(iterable, n) {
  const arr = [...iterable];
  const len = arr.length;
  let _size = null;
  n = n === undefined ? len : n;
  return {
    *[Symbol.iterator]() {
      const toIndex = i => arr[i];

      for (const indices of (0, _product.product)(...(0, _map.map)((0, _range.range)(0, n), () => (0, _range.range)(0, len)))) {
        if ((0, _isSorted.isSorted)(indices)) {
          yield [...(0, _map.map)(indices, toIndex)];
        }
      }
    },

    get size() {
      return _size === null ? _size = combinationsWithReplacementSize(len, n) : _size;
    }

  };
}

var _default = (0, _iterable.iterableCurry)(combinationsWithReplacement, {
  reduces: true,
  minArgs: 0,
  maxArgs: 1
});

exports.default = _default;